// 1. 导入Vue
import Vue from 'vue'
import _ from 'lodash'
import { dateFormat } from '@/util/date'
import { largeHump } from '@/util/index'
import store from '@/store/index'

// 根据 precision（精度） 向下舍入 number。（注： precision（精度）可以理解为保留几位小数。）
Vue.filter('floor', function(number, precision = 2) {
  return _.floor(number, precision)
})

// 根据 precision（精度） 向上舍入 number。（注： precision（精度）可以理解为保留几位小数。）
Vue.filter('ceil', function(number, precision = 2) {
  return _.ceil(number, precision)
})

// 根据 precision（精度） 四舍五入 number。
Vue.filter('round', function(number, precision = 2) {
  return _.round(number, precision)
})

// money
Vue.filter('money', function(number) {
  if (!number) return '0.00'
  number = String(_.ceil(number, 2))
  let int = number.split('.')[0]
  let float = number.split('.')[1] || ''
  switch (float.length) {
    case 0:
      float = '00'
      break
    case 1:
      float = `${float}0`
      break
  }
  return `${int}.${float}`
})

// 数字转千分位
// Vue.filter('thousandth', function(value) {
//   try {
//     const array = String(value).split('.')
//     return Number(array[0]).toLocaleString() + '.' + (array[1] ? (array[1].length === 1 ? array[1] + '0' : array[1]) : '00')
//   } catch (error) {
//     return value
//   }
// })

/**
 * 格式化时间
 */
Vue.filter('dateFormat', function(date) {
  return dateFormat(date)
})

// 金额保留两位  不足用0补充
Vue.filter('numberKeepTwoDecimal', function(value) {
  if (!value) return 0
  value = value.toString()
  let intPart = value.split('.')[0]
  let floatPart = value.split('.')[1]
  if (!floatPart) floatPart = `00`
  if (floatPart.length === 1) floatPart = `${floatPart}0`
  return `${intPart}.${floatPart}`
})

// 时间戳转字符串
Vue.filter('timeToString', function(time) {
  let date = new Date(time)
  let minute = date.getMinutes().toString()
  let seconds = date.getSeconds().toString()
  let hours = date.getHours().toString()
  let month = (date.getMonth() + 1).toString()
  let day = date.getDate().toString()
  if (minute.length === 1) minute = `0${minute}`
  if (seconds.length === 1) seconds = `0${seconds}`
  if (hours.length === 1) hours = `0${hours}`
  if (month.length === 1) month = `0${month}`
  if (day.length === 1) day = `0${day}`
  if (time) return `${date.getFullYear()}-${month}-${day} ${hours}:${minute}:${seconds}`
  else return '-'
})

// 时间戳转字符串
Vue.filter('largeHump', function(string) {
  return largeHump(string)
})

// 金额根据汇率转换
Vue.filter('currencyConversion', function(value) {
  if (!value || typeof value !== 'number') return value
  let rate = store.state.common.currencyRate * 10000
  return (value * 10000 * rate / 100000000).toFixed(2)
})
